/* MM PDP Next — product page behaviour (gallery, variants, cart, delivery, nav). */
(function () {
  'use strict';

  function money(cents) {
    if (typeof window.mmFormatMoneyHtml === 'function') return window.mmFormatMoneyHtml(cents);
    return (cents / 100).toFixed(2);
  }

  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function addToCart(id, qty, sourceEl, imageUrl) {
    if (window.MMCart && typeof window.MMCart.add === 'function') {
      return window.MMCart.add(id, qty, { sourceElement: sourceEl, imageUrl: imageUrl || '', openSheet: true });
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    });
  }

  // Direction-agnostic horizontal scrolling (works in RTL where scrollLeft is negative).
  function centerIn(parent, el, smooth) {
    var pr = parent.getBoundingClientRect(), er = el.getBoundingClientRect();
    var delta = (er.left + er.width / 2) - (pr.left + pr.width / 2);
    if (Math.abs(delta) > 2) parent.scrollBy({ left: delta, behavior: smooth === false ? 'auto' : 'smooth' });
  }

  function init(root) {
    if (root.__mmx) return;
    root.__mmx = true;

    var variants = readJSON(root, '[data-mmx-variants]') || [];
    var t = readJSON(root, '[data-mmx-i18n]') || {};

    /* ---------- Gallery ---------- */
    var track = root.querySelector('[data-mmx-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mmx-thumb]'));
    var countEl = root.querySelector('[data-mmx-count]');
    var current = 0;

    function goTo(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      centerIn(track, slides[i]);
      setActive(i);
    }
    function setActive(i) {
      current = i;
      if (countEl) countEl.textContent = i + 1;
      thumbs.forEach(function (th, k) { th.classList.toggle('is-active', k === i); });
      var th = thumbs[i];
      if (th && th.parentElement && th.parentElement.scrollWidth > th.parentElement.clientWidth) centerIn(th.parentElement, th);
    }
    if (track && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) setActive(slides.indexOf(en.target));
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    thumbs.forEach(function (th) {
      th.addEventListener('click', function () { goTo(parseInt(th.getAttribute('data-mmx-thumb'), 10)); });
    });
    var prev = root.querySelector('[data-mmx-prev]');
    var next = root.querySelector('[data-mmx-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    function goToMedia(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goTo(i); return; }
      }
    }

    /* ---------- Variants ---------- */
    var optsEls = Array.prototype.slice.call(root.querySelectorAll('[data-mmx-opt]'));
    var selected = optsEls.map(function (fs) {
      var on = fs.querySelector('.mmx-val[aria-pressed="true"]');
      return on ? on.getAttribute('data-value') : null;
    });

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < sel.length; k++) { if (v.options[k] !== sel[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    var variant = findVariant(selected) || variants[0];

    function refreshAvailability() {
      optsEls.forEach(function (fs, idx) {
        fs.querySelectorAll('.mmx-val').forEach(function (btn) {
          var trial = selected.slice();
          trial[idx] = btn.getAttribute('data-value');
          var v = findVariant(trial);
          btn.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    var priceEl = root.querySelector('[data-mmx-price]');
    var compareEl = root.querySelector('[data-mmx-compare]');
    var saveEl = root.querySelector('[data-mmx-save]');
    var ppsEl = root.querySelector('[data-mmx-pps]');
    var servEl = root.querySelector('[data-mmx-servings]');
    var expiryWrap = root.querySelector('[data-mmx-expiry-wrap]');
    var expiryEl = root.querySelector('[data-mmx-expiry]');
    var stickyPrice = root.querySelector('[data-mmx-sticky-price]');
    var stickyOpt = root.querySelector('[data-mmx-sticky-opt]');
    var addBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mmx-add]'));

    // Per-serving price arrives in fils (1/1000 BHD, tax included) for 3-decimal precision.
    // mmFormatMoneyTaxed applies the visitor's display currency (BHD or SAR).
    function renderPps(milli) {
      if (!ppsEl) return;
      ppsEl.setAttribute('data-milli', milli);
      if (typeof window.mmFormatMoneyTaxed === 'function') ppsEl.textContent = window.mmFormatMoneyTaxed(milli, 1000);
    }
    if (ppsEl && ppsEl.getAttribute('data-milli')) renderPps(parseInt(ppsEl.getAttribute('data-milli'), 10));
    var buyNow = root.querySelector('[data-mmx-buy-now]');
    var saleBadge = root.querySelector('[data-mmx-sale-badge]');
    var soldBadge = root.querySelector('[data-mmx-soldout-badge]');
    var stockEl = root.querySelector('[data-mmx-stock]');
    var oosEl = root.querySelector('[data-mmx-oos]');
    var lowStock = parseInt(root.getAttribute('data-low-stock'), 10);
    if (isNaN(lowStock)) lowStock = 5;

    function renderAvailability(v) {
      var anyAvailable = variants.some(function (x) { return x.available; });
      root.classList.toggle('is-soldout', !anyAvailable);
      if (soldBadge) soldBadge.hidden = !!(v && v.available);
      if (oosEl) {
        var show = !v || !v.available;
        oosEl.hidden = !show;
        if (show) {
          oosEl.querySelector('[data-mmx-oos-title]').textContent = anyAvailable ? t.oosOptionTitle : t.oosAllTitle;
          oosEl.querySelector('[data-mmx-oos-text]').textContent = anyAvailable ? t.oosOptionText : t.oosAllText;
        }
      }
      if (stockEl) {
        var n = v && v.available ? v.stock : null;
        var low = n != null && n > 0 && n <= lowStock;
        stockEl.hidden = !low;
        if (low) stockEl.querySelector('[data-mmx-stock-text]').textContent = n === 1 ? t.lowStockOne : n === 2 ? t.lowStockTwo : t.lowStock.replace('{n}', n);
      }
    }

    function renderVariant(v) {
      renderAvailability(v);
      if (!v) {
        addBtns.forEach(function (b) {
          b.disabled = true;
          var l = b.querySelector('[data-mmx-add-label]');
          if (l) l.textContent = t.unavailable || 'Unavailable';
        });
        if (buyNow) buyNow.hidden = true;
        return;
      }
      if (priceEl) priceEl.innerHTML = money(v.price);
      if (stickyPrice) stickyPrice.innerHTML = money(v.price);
      if (stickyOpt) stickyOpt.textContent = v.title;
      var onSale = v.compare > v.price;
      if (compareEl) { compareEl.hidden = !onSale; compareEl.innerHTML = onSale ? money(v.compare) : ''; }
      if (saleBadge) {
        saleBadge.hidden = !onSale;
        if (onSale) saleBadge.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
      }
      if (saveEl) {
        saveEl.hidden = !onSale;
        saveEl.textContent = onSale ? (t.save || 'Save') + ' ' + Math.round((v.compare - v.price) * 100 / v.compare) + '%' : '';
      }
      if (ppsEl && v.pps) renderPps(v.pps);
      if (servEl && v.servings > 1) servEl.textContent = v.servings;
      if (expiryWrap) {
        expiryWrap.hidden = !v.expiry;
        if (expiryEl) expiryEl.textContent = v.expiry || '';
      }
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        var l = b.querySelector('[data-mmx-add-label]');
        if (l) l.textContent = v.available ? (b.hasAttribute('data-mmx-sticky-add') ? t.addShort : t.add) : t.soldOut;
      });
      if (buyNow) buyNow.hidden = !v.available;
      if (v.media) goToMedia(v.media);
      if (window.MMBranchInventory) window.MMBranchInventory.updateProductPage(String(v.id));

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    /* ---------- Dropdown (options with more than N values) ---------- */
    function closeDropdown(dd, focusBtn) {
      if (!dd) return;
      var list = dd.querySelector('[data-mmx-dd-list]');
      var btn = dd.querySelector('[data-mmx-dd-btn]');
      if (list.hidden) return;
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
      if (focusBtn) btn.focus();
    }
    function openDropdown(dd) {
      root.querySelectorAll('[data-mmx-dd].is-open').forEach(function (o) { if (o !== dd) closeDropdown(o); });
      var list = dd.querySelector('[data-mmx-dd-list]');
      var btn = dd.querySelector('[data-mmx-dd-btn]');
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      dd.classList.add('is-open');
      var current = list.querySelector('.mmx-val[aria-pressed="true"]') || list.querySelector('.mmx-val');
      if (current) { current.scrollIntoView({ block: 'nearest' }); current.focus({ preventScroll: true }); }
    }
    root.querySelectorAll('[data-mmx-dd]').forEach(function (dd) {
      var btn = dd.querySelector('[data-mmx-dd-btn]');
      var list = dd.querySelector('[data-mmx-dd-list]');
      btn.addEventListener('click', function () { list.hidden ? openDropdown(dd) : closeDropdown(dd); });
      dd.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeDropdown(dd, true); return; }
        if (list.hidden || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
        e.preventDefault();
        var items = Array.prototype.slice.call(list.querySelectorAll('.mmx-val'));
        var i = items.indexOf(document.activeElement);
        var next = items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
        if (next) next.focus();
      });
    });
    document.addEventListener('click', function (e) {
      root.querySelectorAll('[data-mmx-dd].is-open').forEach(function (dd) { if (!dd.contains(e.target)) closeDropdown(dd); });
    });

    function syncDropdownTrigger(fs, btn) {
      var dd = fs.querySelector('[data-mmx-dd]');
      if (!dd) return;
      var current = dd.querySelector('[data-mmx-dd-current]');
      var trigger = dd.querySelector('[data-mmx-dd-btn]');
      var dot = btn.querySelector('.mmx-val__dot');
      var oldDot = current.querySelector('.mmx-val__dot');
      if (oldDot) oldDot.remove();
      if (dot) current.insertBefore(dot.cloneNode(true), current.firstChild);
      current.querySelector('[data-mmx-dd-label]').textContent = btn.getAttribute('data-value');
      trigger.classList.toggle('has-img', btn.classList.contains('has-img'));
      trigger.classList.toggle('is-unavailable', btn.classList.contains('is-unavailable'));
      closeDropdown(dd, true);
    }

    optsEls.forEach(function (fs, idx) {
      var label = fs.querySelector('[data-mmx-opt-label]');
      fs.addEventListener('click', function (e) {
        var btn = e.target.closest('.mmx-val');
        if (!btn) return;
        fs.querySelectorAll('.mmx-val').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          if (b.hasAttribute('aria-selected')) b.setAttribute('aria-selected', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        if (btn.hasAttribute('aria-selected')) btn.setAttribute('aria-selected', 'true');
        selected[idx] = btn.getAttribute('data-value');
        if (label) label.textContent = selected[idx];
        variant = findVariant(selected);
        refreshAvailability();
        syncDropdownTrigger(fs, btn);
        renderVariant(variant);
      });
    });
    refreshAvailability();

    /* ---------- Quantity ---------- */
    var qtyInput = root.querySelector('[data-mmx-qty-input]');
    root.querySelectorAll('[data-mmx-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-mmx-qty-step'), 10);
        qtyInput.value = Math.max(1, Math.min(99, n));
      });
    });
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    /* ---------- Add to cart ---------- */
    function currentImage() {
      var img = slides[current] && slides[current].querySelector('img');
      return img ? img.currentSrc || img.src : '';
    }
    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!variant || !variant.available || btn.classList.contains('is-busy')) return;
        var l = btn.querySelector('[data-mmx-add-label]');
        var original = l ? l.textContent : '';
        btn.classList.add('is-busy');
        addToCart(variant.id, qty(), btn, currentImage())
          .then(function () {
            btn.classList.remove('is-busy');
            btn.classList.add('is-done');
            if (l) l.textContent = t.added || '✓';
            setTimeout(function () { btn.classList.remove('is-done'); if (l) l.textContent = original; }, 1600);
          })
          .catch(function () { btn.classList.remove('is-busy'); });
      });
    });
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (!variant || !variant.available) return;
        buyNow.disabled = true;
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: qty() })
        }).then(function () { window.location.href = rootUrl + 'checkout'; })
          .catch(function () { buyNow.disabled = false; });
      });
    }
    root.querySelectorAll('[data-mmx-quick-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = b.closest('.mmx-pcard');
        var img = card.querySelector('img');
        var sel = card.querySelector('[data-mmx-quick-select]');
        var id = parseInt(sel ? sel.value : b.getAttribute('data-mmx-quick-add'), 10);
        addToCart(id, 1, b, img ? img.src : '')
          .then(function () { b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1400); });
      });
    });

    /* ---------- Delivery cut-off countdown (Asia/Bahrain) ---------- */
    var cutoff = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 20;
    var cutTitle = root.querySelector('[data-mmx-cutoff-title]');
    var cutText = root.querySelector('[data-mmx-cutoff-text]');
    function tick() {
      if (!cutText) return;
      var parts;
      try {
        parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Bahrain', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
          .formatToParts(new Date());
      } catch (e) { return; }
      var h = 0, m = 0;
      parts.forEach(function (p) { if (p.type === 'hour') h = +p.value; if (p.type === 'minute') m = +p.value; });
      if (root.__mmxClock) { h = root.__mmxClock[0]; m = root.__mmxClock[1]; }
      var left = cutoff * 60 - (h * 60 + m);
      if (left > 0) {
        var str = '<b>' + Math.floor(left / 60) + (t.h || 'h') + ' ' + (left % 60) + (t.m || 'm') + '</b>';
        cutText.innerHTML = (t.cutoffToday || '{t}').replace('{t}', str);
        if (cutTitle) cutTitle.textContent = t.titleToday;
      } else {
        cutText.textContent = t.cutoffTomorrow;
        if (cutTitle) cutTitle.textContent = t.titleTomorrow;
      }
    }
    tick();
    setInterval(tick, 30000);
    renderAvailability(variant);

    /* ---------- State preview toolbar (?mmx_preview=1) — client-side only, nothing is saved ---------- */
    if (new URLSearchParams(window.location.search).has('mmx_preview')) {
      var original = JSON.parse(JSON.stringify(variants));
      var ar = (root.getAttribute('data-locale') || '').indexOf('ar') === 0;
      var STATES = [
        ['normal', ar ? 'الوضع الحقيقي' : 'Real data'],
        ['soldout', ar ? 'نفدت بالكامل' : 'Fully sold out'],
        ['current-oos', ar ? 'النكهة الحالية نافدة' : 'Selected option sold out'],
        ['partial', ar ? 'بعض النكهات نافدة' : 'Some options sold out'],
        ['sale', ar ? 'عليه خصم' : 'On sale'],
        ['low', ar ? 'كمية محدودة' : 'Low stock'],
        ['late', ar ? 'بعد وقت التوصيل' : 'After cut-off'],
      ];
      function applyState(key) {
        variants.length = 0;
        JSON.parse(JSON.stringify(original)).forEach(function (x) { variants.push(x); });
        root.__mmxClock = null;
        var cur = findVariant(selected) || variants[0];
        if (key === 'soldout') variants.forEach(function (x) { x.available = false; });
        if (key === 'current-oos') variants.forEach(function (x) { if (x.id === cur.id) x.available = false; });
        if (key === 'partial') variants.forEach(function (x, i) { if (i % 3 === 1) x.available = false; });
        if (key === 'sale') variants.forEach(function (x) { x.compare = Math.round(x.price * 1.25); });
        if (key === 'low') variants.forEach(function (x, i) { x.stock = (i % 4) + 1; });
        if (key === 'late') root.__mmxClock = [21, 15];
        variant = findVariant(selected) || variants[0];
        refreshAvailability();
        renderVariant(variant);
        tick();
        bar.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-k') === key); });
      }
      var bar = document.createElement('div');
      bar.className = 'mmx-preview';
      bar.innerHTML = '<span class="mmx-preview__title">' + (ar ? 'معاينة الحالات' : 'Preview states') + '</span>' +
        STATES.map(function (s) { return '<button type="button" data-k="' + s[0] + '">' + s[1] + '</button>'; }).join('');
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-k]');
        if (b) applyState(b.getAttribute('data-k'));
      });
      root.appendChild(bar);
      bar.querySelector('[data-k="normal"]').classList.add('is-on');
    }

    /* ---------- Offsets for the store's fixed header and bottom nav ---------- */
    function isPinned(el) {
      if (!el || !el.getClientRects().length) return false;
      var cs = getComputedStyle(el);
      return (cs.position === 'sticky' || cs.position === 'fixed') && cs.display !== 'none' && cs.visibility !== 'hidden';
    }
    function layoutOffsets() {
      var top = 0, bottom = 0;
      var h = document.getElementById('mm-header-sticky') || document.querySelector('.header-wrapper, header');
      if (isPinned(h)) {
        var r = h.getBoundingClientRect();
        if (r.bottom > 0) top = Math.round(r.bottom);
      }
      var nav = document.getElementById('mm-bottom-nav');
      if (isPinned(nav)) {
        var nr = nav.getBoundingClientRect();
        if (nr.height > 0) bottom = Math.max(0, Math.round(window.innerHeight - nr.top + 8));
      }
      root.style.setProperty('--mmx-sticky-top', top + 'px');
      root.style.setProperty('--mmx-sticky-bottom', bottom + 'px');
      pinSubnav(top);
      toggleStickyBar(top);
    }

    // Show the bottom add-to-cart bar once the main button scrolls under the header.
    var sticky = root.querySelector('[data-mmx-sticky]');
    var zone = root.querySelector('[data-mmx-atc-zone]');
    function toggleStickyBar(top) {
      if (!sticky || !zone) return;
      var show = zone.getBoundingClientRect().bottom < top && getComputedStyle(sticky).display !== 'none';
      if (sticky.classList.contains('is-visible') !== show) {
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      liftChat(show);
    }

    // Shopify Inbox renders its launcher inside <shopify-chat>'s shadow root, out of
    // reach of the theme's bottom-nav lift. While our bar is visible, nudge the
    // launcher up so the two never overlap (works for both AR/left and EN/right).
    function chatLauncher() {
      var host = document.querySelector('shopify-chat');
      var sr = host && host.shadowRoot;
      return sr ? sr.querySelector('.activator-nudge') || sr.querySelector('.activator') : null;
    }
    function liftChat(on) {
      var el = chatLauncher();
      if (!el) return;
      var lifted = el.hasAttribute('data-mmx-lift');
      if (!on) {
        if (lifted) { el.style.transform = ''; el.removeAttribute('data-mmx-lift'); }
        return;
      }
      if (lifted) return;
      el.style.transition = 'transform 0.25s ease';
      el.style.transform = '';
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      var bottomOffset = parseInt(getComputedStyle(root).getPropertyValue('--mmx-sticky-bottom'), 10) || 0;
      var barTop = window.innerHeight - bottomOffset - sticky.offsetHeight;
      var lift = Math.ceil(r.bottom - barTop + 10);
      if (lift > 0) el.style.transform = 'translateY(' + -lift + 'px)';
      el.setAttribute('data-mmx-lift', '');
    }

    // The theme makes <body> a scroll container (overflow-x: hidden), which
    // disables position: sticky — so the section nav is pinned with JS.
    var subnav = root.querySelector('[data-mmx-subnav]');
    var slot = root.querySelector('[data-mmx-subnav-slot]');
    var contentEnd = root.querySelector('.mmx-content');
    function pinSubnav(top) {
      if (!subnav || !slot) return;
      var h = subnav.offsetHeight;
      slot.style.height = h + 'px';
      var slotTop = slot.getBoundingClientRect().top;
      var endBottom = contentEnd ? contentEnd.getBoundingClientRect().bottom : Infinity;
      var pin = slotTop <= top && endBottom > top + h;
      subnav.classList.toggle('is-pinned', pin);
    }
    layoutOffsets();
    window.addEventListener('resize', layoutOffsets, { passive: true });
    window.addEventListener('scroll', layoutOffsets, { passive: true });

    /* ---------- Section nav scroll-spy ---------- */
    var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-mmx-subnav] a'));
    var spied = navLinks.map(function (a) { return document.querySelector(a.getAttribute('href')); });
    function spy() {
      var y = 140, active = 0;
      spied.forEach(function (el, i) { if (el && el.getBoundingClientRect().top <= y) active = i; });
      navLinks.forEach(function (a, i) { a.classList.toggle('is-active', i === active); });
      var a = navLinks[active];
      if (a && a !== lastSpied && a.parentElement.scrollWidth > a.parentElement.clientWidth) centerIn(a.parentElement, a);
      lastSpied = a;
    }
    var spyRaf, lastSpied = null;
    window.addEventListener('scroll', function () {
      cancelAnimationFrame(spyRaf);
      spyRaf = requestAnimationFrame(spy);
    }, { passive: true });
    var jumpLinks = navLinks.concat(Array.prototype.slice.call(root.querySelectorAll('.mmx-certbar, .mmx-rating')));
    jumpLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var el = document.querySelector(a.getAttribute('href'));
        if (!el) return;
        e.preventDefault();
        var off = parseInt(getComputedStyle(root).getPropertyValue('--mmx-sticky-top'), 10) || 0;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - off - 60, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Share: native sheet on touch devices, menu elsewhere ---------- */
  function initShare(root) {
    var wrap = root.querySelector('[data-mmx-share]');
    if (!wrap || wrap.__mmxShare) return;
    wrap.__mmxShare = true;
    var btn = wrap.querySelector('[data-mmx-share-btn]');
    var menu = wrap.querySelector('[data-mmx-share-menu]');

    // shared link = clean product URL + the selected variant (so the friend opens the same flavour)
    function shareUrl() {
      var u = new URL(window.location.href);
      var v = u.searchParams.get('variant');
      u.search = '';
      u.hash = '';
      if (v) u.searchParams.set('variant', v);
      return u.toString();
    }
    function setMenu(open) {
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    var touch = window.matchMedia('(pointer: coarse)').matches;

    btn.addEventListener('click', function () {
      var url = shareUrl();
      var title = wrap.getAttribute('data-title');
      var text = wrap.getAttribute('data-text') || title;
      if (touch && navigator.share) {
        navigator.share({ title: title, text: text, url: url }).catch(function () {});
        return;
      }
      setMenu(menu.hidden);
    });
    menu.addEventListener('click', function (e) {
      var item = e.target.closest('[data-share]');
      if (!item) return;
      var url = shareUrl();
      var title = wrap.getAttribute('data-title');
      var kind = item.getAttribute('data-share');
      if (kind === 'copy') {
        e.preventDefault();
        var label = item.querySelector('span');
        var orig = label.textContent;
        var done = function () {
          label.textContent = item.getAttribute('data-copied');
          setTimeout(function () { label.textContent = orig; setMenu(false); }, 1400);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
        return;
      }
      var links = {
        whatsapp: 'https://wa.me/?text=' + encodeURIComponent(title + '\n' + url),
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
        x: 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url)
      };
      item.setAttribute('href', links[kind]);
      setTimeout(function () { setMenu(false); }, 0);
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  function boot() { document.querySelectorAll('[data-mmx]').forEach(function (r) { init(r); initShare(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
